<template>
  <CContainer class="pt-5" fluid>
    <CRow>
      <CCol class="col-12">
        <h3 class="pl-3 mb-0 pb-0">APHT Payment</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item active>
            <CIcon name="cil-credit-card" />
            Need Approval
          </b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CCard class="custom-card">
      <CCardBody class="px-0 pb-0">
        <CRow>
          <CCol class="ml-5">
            <CForm>
              <b-input-group>
                <b-input-group-prepend>
                  <b-form-select v-model="table.filterType" :options="table.filterOptions" @change="onChangeFilterType"></b-form-select>
                </b-input-group-prepend>
                <b-input-group-prepend>
                  <b-form-select v-if="table.filterType == 'memoStatus'" v-model="table.filterValue" :options="table.filterValueMemoStatusOptions" style="min-width: 206.5px;"></b-form-select>
                  <b-form-input v-else-if="table.filterType == 'invoiceMemoNo'" v-model="table.filterValue" maxlength="50" autocomplete="off" placeholder="Search"></b-form-input>
                  <b-form-input maxlength="50" v-else type="text" placeholder="Search" v-model="table.filterValue" onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 13"></b-form-input>
                </b-input-group-prepend>
                <b-input-group-append>
                  <CButton size="sm" color="primary" type="submit" style="color: white;" class="btn-icon mr-2 custom-button-action" @click="filterTable">
                    <CIcon name="cil-magnifying-glass" />
                  </CButton>
                </b-input-group-append>
              </b-input-group>
            </CForm>
          </CCol>
        </CRow>
        <CRow class="mt-4">
          <CCol>
            <b-table striped hover show-empty
              responsive="xl"
              :items="table.items"
              :fields="table.fields"
              :busy="!table.isLoaded"
              no-local-sorting no-sort-reset
              @sort-changed="onSortChanged"
            >
              <template slot="empty">
                <div v-if="!table.isLoaded" class="text-center">
                  <b-spinner label="Fetching Data..."></b-spinner>
                </div> 
                <div v-else class="text-center">
                  Tidak ada data
                </div> 
              </template>
              <template #cell(invoiceMemoNo)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(materaiFee)="row">
                {{ $helper.showData(row.value, "number") }}
              </template>
              <template #cell(notaryFee)="row">
                {{ $helper.showData(row.value, "number") }}
              </template>
              <template #cell(pnbpFee)="row">
                {{ $helper.showData(row.value, "number") }}
              </template>
              <template #cell(memoStatus)="row">
                <CBadge v-if="row.value == 'OA'" color="secondary"> On Approval
                </CBadge>
                <CBadge v-else-if="row.value == 'AP'" color="success"> Approved
                </CBadge>
                <CBadge v-else-if="row.value == 'RJ'" color="danger"> Rejected
                </CBadge>
                <CBadge v-else-if="row.value == 'RV'" color="warning"> Need Revise
                </CBadge>
                <CBadge v-else color="secondary"> -
                </CBadge>
              </template>
              <template #cell(action)="row">
                <CButton size="sm" color="primary" title="Detail Kontrak" class="btn-icon mr-1 custom-button-action" @click="$router.push({ name: 'Invoice APHT Detail', params: { invoiceMemoNo: row.item.invoiceMemoNo } })">
                  <b-icon icon="eye"></b-icon>
                </CButton>
              </template>
            </b-table>
            <CCardFooter>
              <PageSizer :totalRows="table.totalRows" :page="table.currentPage" :options="tablePageOptions" @limit-change="onLimitChange" @page-change="onPageChange" />
            </CCardFooter>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </CContainer>
</template>

<script>
export default {
  name: 'InvoiceList',
  data() {
    return {

      tablePageOptions: [
        { value: 10, text: '10'},
        { value: 20, text: '20'},
        { value: 30, text: '30'},
        { value: 40, text: '40'},
        { value: 50, text: '50'}
      ],
      table: {
        isLoaded: false,
        fields: [
          {key: "invoiceMemoNo", label: "No. Kontrak", sortable: true},
          {key: "materaiFee", label: "Biaya Materai", sortable: true},
          {key: "notaryFee", label: "Biaya Notaris", sortable: true},
          {key: "pnbpFee", label: "Biaya PNBP", sortable: true},
          {key: "memoStatus", label: "Status Kontrak", sortable: true},
          { key: "action", label: "Aksi", sortable: false }
        ],

        items: [],

        filterType: "invoiceMemoNo",
        filterOptions: [
          { value: "invoiceMemoNo", text: "No. Kontrak" },
          { value: "materaiFee", text: "Biaya Materai" },
          { value: "notaryFee", text: "Biaya Notaris" },
          { value: "pnbpFee", text: "Biaya PNBP" },
          { value: "memoStatus", text: "Status Kontrak" }
        ],
        filterValue: "",
        filterValueMemoStatusOptions: [
          { value: "OA", text: "On Approval" },
          { value: "AP", text: "Approved" },
          { value: "RJ", text: "Rejected" },
          { value: "RV", text: "Need Revise" }
        ],

        sort: {
          by: null,
          desc: false
        },

        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },
    }
  },
  methods: {

    filterTable(event) {
      event.preventDefault()

      this.getTableItems(this.table.currentPage)
    },

    onChangeFilterType() {
      if (this.table.filterType == "memoStatus") {
        this.table.filterValue = "OA"
      }
      else{
        this.table.filterValue = null
      }
    },

    onLimitChange(newPerPage) {
      this.table.perPage = newPerPage
      this.getTableItems()
    },
  
    onPageChange(newPage) {
      this.getTableItems(newPage)
    },
  
    onSortChanged(ctx) {
      this.table.sort.by = ctx.sortBy
      this.table.sort.desc = ctx.sortDesc
      this.getTableItems(this.table.currentPage)
    },
  
    getTableItems(page = 1) {
      this.table.isLoaded = false
      this.table.items = []
      if(isNaN(page)) {
        this.table.currentPage = 1
      }
      else {
        this.table.currentPage = page
      }
      // URL builder
      let getUrl = "/aphtPayment/getMemoToProcess"
      let params = this.$helper.getBasePagedQuery(this.table.currentPage - 1, this.table.perPage)
      if(!this.$helper.isEmpty(this.table.filterValue)) {
        params['filterType'] = this.table.filterType
        params['filterValue'] = this.table.filterValue
      }
      if(this.table.sort.by != null) {
        params = this.$helper.getBaseSortQuery(this.table.sort, params)
      }
      if(this.table.sortBy != null) {
        params['sortBy'] = this.table.sortBy
        params['asc'] = !this.table.sortDesc
      }

      return this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          sessionStorage.setItem("filterInvoiceRequestType", this.table.filterType)
          sessionStorage.setItem("filterInvoiceRequestValue", this.table.filterValue)
          this.table.items = response.data.data.data
          this.table.totalRows = response.data.data.totalElements
          this.table.totalPages = response.data.data.totalPages
        }
        else{
          this.$helper.toastError(this, "Load Daftar Kontrak Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Daftar Kontrak Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Daftar Kontrak Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.table.isLoaded = true
      })
    }
  },

  created(){
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterInvoiceRequestType"))){
      this.table.filterType = sessionStorage.getItem("filterInvoiceRequestType")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterInvoiceRequestValue"))){
      this.table.filterValue = sessionStorage.getItem("filterInvoiceRequestValue")
    }
    this.getTableItems()
  },
}
</script>

<style scoped>
</style>
